import React from 'react';
import PropTypes from 'prop-types';
import { session_penalties_url } from './teacher_payments_link';

// The only payment entry point on a session page: a link to this class in Teacher Payments.
export default function TeacherPaymentsLink({ teacher_uuid, epoch_start_time }) {
  return (
    <p style={{ margin: '8px 0', fontSize: '14px' }}>
      <a
        style={{ color: 'var(--text-link-brand)', fontWeight: 600, textDecoration: 'underline' }}
        href={session_penalties_url({ teacher_uuid, epoch_start_time })}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="view-in-teacher-payments"
      >
        View in Teacher Payments
      </a>
    </p>
  );
}

TeacherPaymentsLink.propTypes = {
  teacher_uuid: PropTypes.string,
  epoch_start_time: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

TeacherPaymentsLink.defaultProps = { teacher_uuid: '', epoch_start_time: 0 };
